import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material';
import { TourMatMenuModule } from 'ngx-tour-md-menu';
import { CedantSelectorViewComponent} from './cedant-selector-view/cedant-selector-view.component';
import { CedantViewComponent } from './cedant-view/cedant-view.component';
import { CedantDashboardComponent } from './cedant-dashboard/cedant-dashboard.component';
import { CedantProgramViewComponent } from './cedant-program-view/cedant-program-view.component';
import { CedantProgramDetailsComponent } from './cedant-program-details/cedant-program-details.component';
import { RouterModule } from '@angular/router';
import { CedantRoutes } from './cedant.routing';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    CedantSelectorViewComponent,
    CedantViewComponent,
    CedantDashboardComponent,
    CedantProgramViewComponent,
    CedantProgramDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSidenavModule,
    TourMatMenuModule,
    RouterModule.forChild(CedantRoutes)
  ]
})
export class CedantModule { }
